<template>
  <div class="upload_works">
    <van-nav-bar :title="title" fixed placeholder @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="16" color="#323233" />
      </template>
    </van-nav-bar>
    <div class="upload_works_title">
      <van-icon name="warning" style="margin-right: 4px" />{{
        $t('message.activity_upload_works.please')
      }}<span @click="showTouClick">{{ $t('message.activity_upload_works.con_rules') }}</span
      >，{{ $t('message.activity_upload_works.speak') }}
    </div>
    <van-form ref="form" class="upload_works_flex" label-width="100%">
      <van-field
        :label="$t('message.activity_upload_works.realname')"
        v-if="activityData.showName"
        v-model="queryInfo.signUpName"
        :placeholder="$t('message.activity_upload_works.pleasename')"
        disabled
        :rules="[{ required: true, message: $t('message.activity_upload_works.realname') }]"
      >
      </van-field>
      <!-- IDCard -->
      <van-field
        :label="$t('message.activity_upload_works.idnumber')"
        v-if="(activityData.notIdCard && index === 4) || (index === 6 && activityData.notIdCard)"
        v-model="queryInfo.idCard"
        disabled
        :placeholder="$t('message.activity_upload_works.pleaseID')"
        :rules="IDCard"
      >
      </van-field>
      <van-field
        :label="$t('message.activity_upload_works.school')"
        disabled
        v-if="activityData.showSchool"
        v-model="queryInfo.signUpSchool"
        :placeholder="$t('message.activity_upload_works.please_school')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.pleadeenter') }]"
      >
      </van-field>
      <!--  :rules="telRules" 手机号 -->
      <van-field
        v-if="activityData.showPhone"
        :label="$t('message.activity_upload_works.contact')"
        type="number"
        disabled
        v-model="queryInfo.signUpPhone"
        :placeholder="$t('message.activity_upload_works.contact')"
      >
      </van-field>

      <van-field
        v-if="activityData.displayGroup"
        name="radio"
        :label="$t('message.activity_upload_works.group')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.pleasegroup') }]"
      >
        <template #input>
          <van-radio-group v-model="queryInfo.tranches" direction="horizontal">
            <van-radio
              disabled
              style="width: 100%; margin-bottom: 10px"
              v-for="(item, index) in codeListZu"
              :key="index"
              :name="item.codeName"
              >{{ item.codeName }}</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        disabled
        name="picker"
        :value="queryInfo.competitionArea"
        :label="$t('message.activity_upload_works.region')"
        :placeholder="$t('message.activity_upload_works.clickcity')"
      />

      <div class="new_form_title">
        <span></span>
        <p>{{ $t('message.activity_upload_works.work_infom') }}</p>
      </div>
      <van-field
        v-if="index === 6"
        name="radio"
        :label="$t('message.activity_upload_works.worktype')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.pleasetype') }]"
      >
        <template #input>
          <van-radio-group v-model="queryInfo.scienceType" direction="horizontal">
            <van-radio v-for="(item, index) in codeListType" :key="index" :name="item">{{
              item
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="queryInfo.workTitle"
        :label="$t('message.activity_upload_works.worktitle')"
        :placeholder="$t('message.activity_upload_works.worktitle')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.pleasetitle') }]"
      />
      <van-field
        v-if="index === 3"
        v-model="queryInfo.filmingLocation"
        :label="$t('message.activity_upload_works.photography')"
        :placeholder="$t('message.activity_upload_works.Pleasephotographed')"
        :rules="[
          { required: true, message: $t('message.activity_upload_works.Pleasephotographed') }
        ]"
      />
      <!-- queryInfo.filmingLocation -->
      <van-field
        v-model="queryInfo.workDescribe"
        :label="$t('message.activity_upload_works.description')"
        type="textarea"
        :placeholder="$t('message.activity_upload_works.pleasedescription')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.descriptionworks') }]"
      />

      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.Pleaseupload')"
        v-if="index === 1 || index === 3 || index === 4"
        :rules="[{ required: true, message: $t('message.activity_upload_works.Pleaseupload') }]"
      >
        <template #input>
          <div class="flex">
            <van-uploader
              v-model="fileList"
              :max-count="12"
              multiple
              :after-read="afterReadNew"
              :before-delete="closeImg"
              :max-size="isOverSize"
              accept="image/jpg,image/jpeg"
            />
            <div style="width: 100%">
              <div class="annotation" v-for="(item, index) in mapList" :key="index">
                <van-field
                  v-model="item.pointsThat"
                  rows="1"
                  type="textarea"
                  :placeholder="$t('message.activity_upload_works.photo_tip')"
                />
              </div>
            </div>
          </div>
        </template>
      </van-field>
      <van-field>
        <template #input>
          <div class="flex">
            <span class="span" v-if="index === 3">
              <van-icon name="warning" style="margin-right: 4px" />
              <span v-html="$t('message.activity_upload_works.imgroul')"></span>
            </span>
            <span class="span" v-if="index === 4">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.opJPG')
              }}
            </span>
          </div>
        </template>
      </van-field>

      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.opscientific')"
        v-if="index === 6 && queryInfo.scienceType === $t('message.activity_upload_works.scworks')"
        :rules="[{ required: true, message: $t('message.activity_upload_works.opscientific') }]"
      >
        <template #input>
          <div class="flex">
            <van-uploader
              v-model="fileList"
              :max-count="20"
              multiple
              :after-read="afterReadNew"
              :before-delete="closeImg"
            />
            <span class="span">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.pleasephoto')
              }}</span
            >
          </div>
        </template>
      </van-field>

      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.programming')"
        v-if="index === 6 && queryInfo.scienceType === $t('message.activity_upload_works.greative')"
      >
        <template #input>
          <div class="flex" style="flex-direction: column">
            <van-uploader
              v-model="fileListVideo"
              accept="video/mp4"
              :max-count="5"
              :after-read="afterReadVideo"
              :before-delete="closeImgVideo"
              :before-read="beforeRead"
              :max-size="1000 * 1000 * 1024"
              @oversize="onOversize"
            />
            <span class="span">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.plerasemp4')
              }}
            </span>
          </div>
        </template>
      </van-field>
      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.plworke')"
        v-if="index === 5 || index === 7"
        :rules="[{ required: true, message: $t('message.activity_upload_works.plworke') }]"
      >
        <template #input>
          <div class="flex">
            <van-uploader
              v-model="fileList"
              :max-count="12"
              multiple
              :after-read="afterReadNew"
              :before-delete="closeImg"
              :max-size="isOverSize"
              accept="image/jpg,image/jpeg"
            />
          </div>
        </template>
      </van-field>

      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.plvideo')"
        v-if="index === 5 || index === 7"
        :rules="[{ required: true, message: $t('message.activity_upload_works.plvideo') }]"
      >
        <template #input>
          <div class="flex">
            <van-uploader
              v-model="fileListVideo"
              accept="video/mp4"
              :before-read="beforeRead"
              :max-size="1000 * 1000 * 1024"
              @oversize="onOversize"
              :max-count="1"
              :after-read="afterReadVideo"
              :before-delete="closeImgVideo"
            />
            <!-- <span class="span">
              <van-icon
                name="warning"
                style="margin-right: 4px"
              />动画：须提供MPG、AVI或MOV格式文件；原始分辨率不小于800×600像素（建议文件压缩到1G以下）。
              3.4新媒体动画：Flash文件须提供SWF格式文件，原始分辨率不小于550px×330px(建议分辨率720px×576px)。
            </span> -->
          </div>
        </template>
      </van-field>
      <van-field
        name="uploader"
        :label="$t('message.activity_upload_works.plvideo')"
        v-if="index === 2"
        :rules="[
          {
            required: !tiffNameList.length != 0,
            message: $t('message.activity_upload_works.plvideo')
          }
        ]"
      >
        <template #input>
          <div class="flex" style="flex-direction: column">
            <div style="font-size: 10px; color: #999999; margin-bottom: 5px">
              <van-icon name="warning" style="margin-right: 4px" />
              文件视频时长要求<span style="color: #3360ff">三分钟</span>以内，<span
                style="color: #3360ff"
                >MP4、MPG、MOV</span
              >格式均可，像素不低于<span style="color: #3360ff">1080p</span>，文件大小<span
                style="color: #3360ff"
                >1G</span
              >以内，最多上传<span style="color: #3360ff">1</span
              >个视频。拍摄时间不限，拍摄设备不限，作品描述中须注明拍摄时间、地点、拍摄内容简述，中英文兼具更佳
            </div>

            <van-uploader
              v-model="fileListVideo"
              accept="video/mp4"
              :max-count="1"
              :before-read="beforeRead1"
              :after-read="afterReadVideo"
              :max-size="1000 * 1000 * 1024"
              @oversize="onOversize"
              :before-delete="closeImgVideo"
            /><span class="span">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.plerasemp4')
              }}
            </span>
          </div>
        </template>
      </van-field>
      <van-field
        name="uploader"
        label=""
        v-if="index === 2"
        :rules="[
          {
            required: !videoId.length != 0,
            message: $t('message.activity_upload_works.plvideo')
          }
        ]"
      >
        <template #input>
          <div class="flex" style="flex-direction: column">
            <van-uploader
              v-model="fileListTiff"
              accept="video/quicktime,video/mpeg"
              :max-count="1"
              :before-read="beforeReadTiff2"
              :after-read="afterReadVideo1"
              :max-size="1000 * 1000 * 1024"
              @oversize="onOversize"
              :before-delete="closeImgTiff"
            /><span class="span">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.mpgmov')
              }}
            </span>
          </div>
        </template>
      </van-field>
      <div style="padding: 5px 0" v-if="fileList.length > 0 && rate != 100">
        <van-progress :percentage="rate" />
      </div>

      <van-field
        name="uploader"
        label=""
        v-if="index === 6 && queryInfo.scienceType === $t('message.activity_upload_works.greative')"
      >
        <template #input>
          <div class="flex" style="flex-direction: column">
            <van-uploader
              v-model="fileListTiff"
              accept="video/quicktime,video/mpeg"
              :max-count="5"
              :before-read="beforeReadTiff1"
              :after-read="afterReadVideo1"
              :max-size="1000 * 1000 * 1024"
              :before-delete="closeImgTiff"
              @oversize="onOversize"
            /><span class="span">
              <van-icon name="warning" style="margin-right: 4px" />{{
                $t('message.activity_upload_works.mpgmov')
              }}
            </span>
          </div>
        </template>
      </van-field>
      <!-- <h1>dfasdf</h1> -->
      <!-- <van-field
        maxlength="100"
        type="textarea"
        v-if="index === 3"
        :label="$t('message.activity_upload_works.sub_des')"
        v-model="queryInfo.pictureDescription"
        :placeholder="$t('message.activity_upload_works.pleasedescrible')"
      /> -->
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="SaiquList"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-popup v-model="showArea" position="bottom">
        <van-area :area-list="areaList" @confirm="onConfirmA" @cancel="showArea = false" />
      </van-popup>
    </van-form>
    <div class="p">
      {{ $t('message.activity_upload_works.byagree') }}
      <span @click="responsClickTxt">{{ $t('message.activity_upload_works.sprules') }}</span>
    </div>
    <div class="div">
      <van-checkbox icon-size="16px" v-model="checkedAgges"
        ><div class="aggess">
          {{ $t('message.activity_upload_works.myagree')
          }}<span @click="showClickTxt">{{
            $t('message.activity_upload_works.contribution')
          }}</span>
        </div></van-checkbox
      >
    </div>
    <div class="btn">
      <van-button @click="btn" :disabled="display">{{
        $t('message.activity_upload_works.submit')
      }}</van-button>
    </div>
    <div class="fixed" @click="showTouClick">
      <img src="../../../../static/image/fixed-buttom.png" alt="" />
    </div>
    <van-popup v-model="showTxt" class="text_pop">
      <txt-pop />
    </van-popup>
    <van-popup v-model="showTou" class="tou_pop">
      <div class="show_tou">
        <h4>{{ $t('message.activity_upload_works.con_rules') }}</h4>
        <div
          class="div"
          v-if="index === 1"
          v-html="activityData.contributeSubmissionInstructions"
        ></div>
        <div class="div" v-if="index === 2" v-html="activityData.contributeSubmitDetails"></div>
        <div class="div" v-if="index === 3" v-html="activityData.photoContribute"></div>
        <div class="div" v-if="index === 4" v-html="activityData.paintingContribute"></div>
        <div class="div" v-if="index === 5" v-html="activityData.animeContribute"></div>
        <div class="div" v-if="index === 6" v-html="activityData.scienceContribute"></div>
        <!-- <div class="div" v-if="index === 7" v-html="activityData.contributeSubmissionInstructions"></div> -->
      </div>
    </van-popup>
    <div class="pop_cenll" v-if="show">
      <van-circle v-model="authProgress" :rate="0" :text="text" />
      <!-- <div v-if="videoName">
        <div class="pop_show" v-for="(item, index) in videoName" :key="index">
          <p class="name">{{ item.name }}</p>
          <van-progress :percentage="item.rate" />
        </div>
      </div>
      <div v-if="imgNameList">
        <div class="pop_show" v-for="(item, index) in imgNameList" :key="index">
          <p class="name">{{ item.name }}</p>
          <van-progress :percentage="item.rate" />
        </div>
      </div>
      <div v-if="tiffNameList">
        <div class="pop_show" v-for="(item, index) in tiffNameList" :key="index">
          <p class="name">{{ item.name }}</p>
          <van-progress :percentage="item.rate" />
        </div>
      </div> -->
    </div>
    <van-popup v-model="responsShow" class="text_pop">
      <respons-text @ResponsTextClose="ResponsTextClose" />
    </van-popup>
  </div>
</template>

<script>
import { client } from '../../../utils/oss'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { codeList } from '@/api/common'
import { getCookie } from '@/utils/cookie'
import { areaList } from '@vant/area-data'
import axios from 'axios'
import {
  getThemeWork,
  savePictureWorkOne,
  getSaiqu,
  getDetailActivity,
  verdictSave,
  isSignUpOne
} from '@/api/activity'
import TxtPop from './common/TxtPop.vue'
import ResponsText from './common/ResponsText.vue'
const defaultQuery = Object.freeze({
  activityId: '',
  idCard: '',
  videoId: [],
  workTiffList: [], //tiff
  competitionArea: '', //赛区
  filmingLocation: '', //拍摄地点
  tag: '', //标题
  theme: '', //主题
  userId: '', //用户编号
  videoIdList: [],
  signUpName: '',
  signUpSchool: '',
  signUpPhone: '',
  tranches: '',
  scienceType: '',
  workDescribe: '', //作品描述
  workList: [], //作品的url
  workTitle: '', //作品标题
  workVideoList: [], //视频
  worksType: 1, //作品类型
  pictureDescription: ''
})
export default {
  components: { TxtPop, ResponsText },
  name: 'signUpUploadWorks',
  computed: {
    id() {
      return this.$route.query.id
    },
    index() {
      return this.$route.query.index * 1
    },
    isWhether() {
      return this.$route.query.isWhether * 1
    },
    userMyId() {
      return this.$route.query.userMyId * 1
    },
    divisionName() {
      return this.$route.query.divisionName
    },
    Authorization() {
      return getCookie('token')
    },
    text() {
      return this.authProgress.toFixed(0) + '%'
    }
  },
  data() {
    return {
      videoId: [],
      idList: [],
      vid: '',
      fileTitle: '',
      timeout: '',
      partSize: '',
      parallel: '',
      retryCount: '',
      retryDuration: '',
      region: 'cn-shanghai',
      userIdAli: '1420746387884027',
      file: null,
      authProgress: 0,
      fileListState: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      uploader: null,
      statusText: '',
      mapListUrl: [],
      responsShow: false,
      videoName: [],
      imgNameList: [],
      tiffNameList: [],
      show: false,
      userId: 0,
      rate: 0,
      currentRate: 0,
      path: `${process.env.VUE_APP_INDEX_API}`,
      socket: '',
      codeListType: [
        this.$t('message.activity_upload_works.scworks'),
        this.$t('message.activity_upload_works.greative')
      ],
      codeListZu: [],
      telRules: [
        {
          required: true,
          message: this.$t('message.activity_upload_works.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /0?(13|14|15|17|18|19)[0-9]{9}/.test(value)
          },
          message: this.$t('message.activity_upload_works.phone_rules'),
          trigger: 'onBlur'
        }
      ],
      IDCard: [
        {
          required: true,
          message: this.$t('message.activity_upload_works.Id_null'),
          trigger: 'onBlur'
        },
        {
          //自定义校验规则
          validator: (value) => {
            return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value)
          },
          message: this.$t('message.activity_upload_works.pleaseID'),
          trigger: 'onBlur'
        }
      ],
      showTou: false,
      showTxt: false,
      activityData: {},
      areaList: {},
      checked: true,
      showArea: false,
      queryInfo: { ...defaultQuery },
      fileList: [],
      fileListVideo: [],
      fileListTiff: [],
      showPicker: false,
      display: false,
      checkedAgges: true,
      threeLits: [],
      SaiquList: [],
      title: '',
      mapList: [],
      formDataUrl: '',
      mapVideoList: [],
      mapTiifList: [],
      filesListName: [],
      filesListSize: [],
      filesListNum: [],
      uploadTime: null
    }
  },
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    this.getTitle()
    this.getTheme()
    this.getListShow()
    this.getActivityData()
    this.getCodeAllZu()
    this.areaList = areaList
    this.userId = getCookie('userId')
    this.loginSignUp()
    // this.userId = sessionStorage.getItem('userId')
  },
  methods: {
    async loginSignUp() {
      console.log(this.$route.query.userMyId)
      const { data: res } = await isSignUpOne({ id: this.userMyId })
      if (res.resultCode === 200) {
        if (res.data != null) {
          this.queryInfo = res.data
          this.btnShow = true
        } else {
          this.btnShow = false
        }
      }
    },
    responsClickTxt() {
      this.responsShow = true
    },
    isOverSize(file) {
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      let re = false
      const imgFormat = /image\/(jpeg|jpg)$/
      const type = file.type
      const size = file.size / 1024 / 1024 < 1
      this.filesListNum.push(file.name)
      console.log(size)
      // 图片格式判断
      if (!imgFormat.test(type)) {
        this.filesListName.push(file.name + '\n')
        re = true
      }

      // 图片大小判断
      if (size) {
        this.filesListSize.push(file.name + '\n')
        re = true
      }
      if (this.mapListUrl.length == 0) {
        this.filesListNum = []
      }
      // console.log(this.filesListName)
      this.uploadTime = setTimeout(() => {
        this.uploadImgLose()
        this.filesListName = []
        this.filesListSize = []
        this.filesListNum = []
      }, 100)
      return re
    },
    // 上传不规范图片提示
    uploadImgLose() {
      // 清除定时器
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      // 图片类型
      let filesListNameS = []
      // 图片大小
      let filesListSizeS = []
      // 图片总数
      let filesListNumS = []

      filesListNameS = [...new Set(this.filesListName)]
      filesListSizeS = [...new Set(this.filesListSize)]
      filesListNumS = [...new Set(this.filesListNum)]
      if (filesListNameS.length != 0 || filesListSizeS.length != 0) {
        if (filesListNumS.length + this.mapListUrl.length > 12) {
          Toast.fail('组图上传总数量不能大于12张')
        }
      } else {
        if (this.mapListUrl.length >= 12) {
          Toast.fail('组图上传总数量不能大于12张')
        }
      }

      if (filesListNameS.length != 0) {
        Toast({
          message: '以下图片格式不正确\n' + filesListNameS.join('')
        })
      }
      if (filesListSizeS.length != 0) {
        Toast({
          message: '以下图片大小不能小于1M\n' + filesListSizeS.join('')
        })
      }
    },
    beforeRead(file) {
      if (this.tiffNameList.length + this.videoId.length >= 5) {
        Toast.fail('最多上传5个视频')
        return false
      }
      if (file.type !== 'video/mp4') {
        Toast(this.$t('message.activity_upload_works.enter_id'))
        return false
      }
      if (file.size > 1024 * 1024 * 1024) {
        Toast.fail('文件大小不能大于1G')
        return false
      }

      // console.log('````````````')
      let url = URL.createObjectURL(file)
      let audioElement = new Audio(url)
      let result
      audioElement.muted = true
      audioElement.play().then(() => audioElement.pause())
      return new Promise((resolve, reject) => {
        audioElement.addEventListener('loadedmetadata', function () {
          result = audioElement.duration
          let serce = parseInt(result)
          if (serce > 180) {
            audioElement.muted = false
            Toast('视频不能超过三分钟')
            reject()
          } else {
            audioElement.muted = false
            resolve()
          }
        })
      })
    },
    // index等于2  并且是mp4格式视频上传前的判断
    beforeRead1(file) {
      //视频
      if (this.tiffNameList.length + this.videoId.length >= 1) {
        Toast.fail('最多上传一个视频')
        return false
      }
      if (file.type !== 'video/mp4') {
        Toast(this.$t('message.activity_upload_works.enter_id'))
        return false
      }
      if (file.size > 1024 * 1024 * 1024) {
        Toast.fail('文件大小不能大于1G')
        return false
      }

      // console.log('````````````')

      let url = URL.createObjectURL(file)
      let audioElement = new Audio(url)
      let result
      audioElement.muted = true
      audioElement.play().then(() => audioElement.pause())
      return new Promise((resolve, reject) => {
        audioElement.addEventListener('loadedmetadata', function () {
          result = audioElement.duration
          let serce = parseInt(result)
          if (serce > 180) {
            audioElement.muted = false
            Toast('视频不能超过三分钟')
            reject()
          } else {
            audioElement.muted = false
            resolve()
          }
        })
      })

      // return true
    },

    onOversize() {
      Toast(this.$t('message.activity_upload_works.file_1g'))
    },
    async getCodeAllZu() {
      const lang = sessionStorage.getItem('lang')
      const { data: res } = await codeList({ code: '004', language: lang })
      if (res.resultCode === 200) {
        this.codeListZu = res.data
      }
    },
    async getActivityData() {
      // const url = 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
      const { data: res } = await getDetailActivity({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName: ''
      })
      if (res.resultCode === 200) {
        // res.data.activeImageList = res.data.activeImageList.map((el) => {
        //   return url + el
        // })
        this.activityData = res.data
      }
    },
    showTouClick() {
      this.showTou = true
    },
    showClickTxt() {
      this.showTxt = true
    },
    getTitle() {
      if (this.index === 1) {
        this.title = this.$t('message.activity_upload_works.up_pic')
      } else if (this.index === 2) {
        this.title = this.$t('message.activity_upload_works.up_videos')
      } else if (this.index === 3) {
        this.title = this.$t('message.activity_upload_works.up_photo')
      } else if (this.index === 4) {
        this.title = this.$t('message.activity_upload_works.up_pain')
      } else if (this.index === 5) {
        this.title = this.$t('message.activity_upload_works.up_animation')
      } else if (this.index === 6) {
        this.title = this.$t('message.activity_upload_works.up_scientific')
      } else if (this.index === 7) {
        this.title = this.$t('message.activity_upload_works.up_music')
      }
    },
    onConfirmA(values) {
      this.queryInfo.filmingLocation = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showArea = false
    },
    async submitClick() {
      this.queryInfo.activityId = this.id
      this.queryInfo.worksType = this.index
      if (this.mapVideoList.length > 0) {
        this.queryInfo.videoId = this.idList
      } else {
        this.queryInfo.videoId = []
      }
      if (this.mapTiifList.length > 0) {
        this.queryInfo.workTiffList = this.tiffNameList
      } else {
        this.queryInfo.workTiffList = []
      }
      if (this.mapList) {
        this.queryInfo.workList = this.mapList
        this.queryInfo.pictureDescription = this.mapList.map((item) => {
          return item.pointsThat
        })
        this.queryInfo.pictureDescription = this.queryInfo.pictureDescription.join('-')
        console.log(this.queryInfo.pictureDescription)
      } else {
        this.queryInfo.workList = []
      }
      if (this.queryInfo.worksType == 3 || this.queryInfo.worksType == 4) {
        this.queryInfo.works = '作品上传标识'
      }
      if (
        this.queryInfo.scienceType == this.$t('message.activity_upload_works.scworks') &&
        this.queryInfo.worksType == 6
      ) {
        this.queryInfo.works = '作品上传标识'
      }
      this.queryInfo.isWhether = this.isWhether
      // console.log(this.queryInfo)
      // if (this.queryInfo) {
      //   return
      // }

      const { data: res } = await savePictureWorkOne(this.queryInfo)
      if (res.resultCode === 200) {
        this.$toast(this.$t('message.activity_upload_works.up_work'))
        this.show = false
        this.display = true
        this.fileList = []
        this.checkedAgges = false
        this.checkedAggesID = false
        Object.assign(this.queryInfo, defaultQuery)
        setTimeout(() => {
          location.assign('/activity/details?id=' + this.id)
        }, 1000)
      } else if (res.resultCode === 500) {
        Dialog.alert({
          title: this.$t('message.activity_upload_works.prompt'),
          message: res.message
        }).then(() => {
          // on close
          this.show = false
        })
      } else {
        this.$toast.fail(this.$t('message.activity_upload_works.up_failed'))
        setTimeout(() => {
          location.assign('/activity/details?id=' + this.id)
        }, 1000)
      }
    },
    //websocket
    init: function () {
      if (typeof WebSocket === 'undefined') {
        alert(this.$t('message.activity_upload_works.not_socket'))
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path + '/' + this.userId)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    open: function () {
      // console.log('socket连接成功')
    },
    error: function () {
      // console.log('连接错误')
    },
    getMessage: function (msg) {
      const obj = msg.data
      let list = obj.split('$')
      let arr = this.videoName.concat(this.imgNameList).concat(this.tiffNameList)
      // for (var i = 0; i <= arr.length; i++) {
      //   if (arr[i].name === list[0]) {
      //     arr[i].rate = list[1]
      //   }
      // }
      arr.forEach((el) => {
        if (el.name === list[0]) {
          el.rate = list[1]
        }
      })
    },
    send: function () {
      this.socket.send()
    },
    close: function () {
      // console.log('socket已经关闭')
    },
    async getListShow() {
      const { data: res } = await getSaiqu({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang')
      })
      if (res.resultCode === 200) {
        if (res.data === null) {
          this.SaiquList = []
        } else {
          this.SaiquList = res.data
          if (getCookie('divisionName')) {
            this.queryInfo.competitionArea = getCookie('divisionName')
          } else {
            this.queryInfo.competitionArea = this.SaiquList[0]
          }
        }
      }
    },
    // 科创
    beforeReadTiff1(file) {
      // console.log(file)
      if (this.tiffNameList.length + this.videoId.length >= 5) {
        Toast.fail('最多上传5个视频')
        return false
      }
      if (file.size > 1024 * 1024 * 1024) {
        Toast.fail('文件大小不能大于1G')
        return false
      }

      // console.log('````````````')
      let url = URL.createObjectURL(file)
      let audioElement = new Audio(url)
      let result
      audioElement.muted = true
      audioElement.play().then(() => audioElement.pause())
      return new Promise((resolve, reject) => {
        audioElement.addEventListener('loadedmetadata', function () {
          result = audioElement.duration
          let serce = parseInt(result)
          if (serce > 180) {
            audioElement.muted = false
            Toast('视频不能超过三分钟')
            reject()
          } else {
            audioElement.muted = false
            resolve()
          }
        })
      })
      // return true
    },
    onConfirm(value) {
      this.queryInfo.competitionArea = value
      this.showPicker = false
    },
    async getTheme() {
      const { data: res } = await getThemeWork({
        id: this.id,
        language: sessionStorage.getItem('lang') == '' ? '' : sessionStorage.getItem('lang'),
        divisionName:
          sessionStorage.getItem('divisionName') == '' ? '' : sessionStorage.getItem('divisionName')
      })
      if (res.resultCode === 200) {
        this.threeLits = res.data
      }
    },
    beforeReadTiff2(file) {
      console.log(file)
      // console.log(this.tiffNameList)
      // 正确的视频后缀会有mime信息

      if (this.tiffNameList.length + this.videoId.length >= 1) {
        Toast.fail('最多上传一个视频')
        return false
      }
      if (file.size > 1024 * 1024 * 1024) {
        Toast.fail('文件大小不能大于1G')
        return false
      }

      // console.log('````````````')
      let url = URL.createObjectURL(file)
      let audioElement = new Audio(url)
      let result
      audioElement.muted = true
      audioElement.play().then(() => audioElement.pause())
      return new Promise((resolve, reject) => {
        audioElement.addEventListener('loadedmetadata', function () {
          result = audioElement.duration
          let serce = parseInt(result)
          if (serce > 180) {
            audioElement.muted = false
            Toast('视频不能超过三分钟')
            reject()
          } else {
            audioElement.muted = false
            resolve()
          }
        })
      })
      // return true
    },
    initDay() {
      const date = new Date().getTime() // 得到当前时间
      return `-${date}`
    },
    //上传图片
    afterReadNew(file) {
      if (file instanceof Array) {
        file.map((el) => {
          let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
          let a = t.length
          let n = process.env.VUE_APP_UPLOAD_API
          for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
          n = n + this.initDay()
          let sub = el.file.name.split('.')
          n = n + '.' + sub[sub.length - 1]
          var names = el.file.name.replace(/ +/g, '')
          var name = names.replace(/\+/g, '')
          name = name.replace(/#/g, '-')
          name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
          var getName = process.env.VUE_APP_UPLOAD_API + name
          var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
          client()
            .multipartUpload(n, el.file)
            .then((res) => {
              let imageUrlObj = {}
              this.fileListState++
              this.rate = parseInt((100 / this.fileList.length) * this.fileListState)
              imageUrlObj.fileName = res.res.requestUrls[0]
              imageUrlObj.fileUrl = res.res.requestUrls[0]
              imageUrlObj.fileType = 1
              imageUrlObj.type = 1
              file.status = ''
              file.message = ''
              this.mapList.push({ works: n, pointsThat: '', originalWork: el.file.name })
              this.mapListUrl.push(imageUrlObj.fileUrl)
            })
            .catch((err) => {
              console.log(err)
            })
        })
      } else {
        let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let a = t.length
        let n = process.env.VUE_APP_UPLOAD_API
        for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
        n = n + this.initDay()
        let sub = file.file.name.split('.')
        n = n + '.' + sub[sub.length - 1]
        this.rate = 0
        var names = file.file.name.replace(/ +/g, '')
        var name = names.replace(/\+/g, '')
        name = name.replace(/#/g, '-')
        name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
        let getName = process.env.VUE_APP_UPLOAD_API + name
        var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀

        client()
          .multipartUpload(n, file.file)
          .then((res) => {
            let imageUrlObj = {}
            this.fileListState++
            this.rate = 100
            imageUrlObj.fileName = res.res.requestUrls[0]
            imageUrlObj.fileUrl = res.res.requestUrls[0]
            imageUrlObj.fileType = 1
            imageUrlObj.type = 1
            file.status = ''
            file.message = ''
            this.mapList.push({ works: n, pointsThat: '', originalWork: file.file.name })
            this.mapListUrl.push(imageUrlObj.fileUrl)
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // console.log(this.mapList);
    },
    // 关闭权责说明弹窗
    ResponsTextClose() {
      this.responsShow = false
    },

    //删除图片回调
    closeImg(file, detail) {
      this.fileList.splice(detail.index, 1)
      this.mapList.splice(detail.index, 1)
      this.imgNameList.splice(detail.index, 1)
      this.fileListState--
      if (this.fileList.length == 0) {
        this.rate = 0
      }
    },
    //上传视频
    afterReadVideo(file) {
      var userData = '{"Vod":{}}'
      this.uploader = this.createUploader()
      this.mapVideoList.push(file.file)
      this.videoName.push({
        name: file.file.name,
        rate: 0
      })
      this.uploader.addFile(file.file, null, null, null, userData)
      this.show = true
      this.uploader.startUpload()
    },

    //删除视频回调
    closeImgVideo(file, detail) {
      Dialog.confirm({
        message: '确定要删除此视频吗'
      })
        .then(() => {
          this.uploader = this.createUploader()
          this.fileListVideo.splice(detail.index, 1)
          this.videoId.splice(detail.index, 1)
          this.mapVideoList.splice(detail.index, 1)
          this.uploader.deleteFile(detail.index) //需要删除的文件index，对应listFiles接口返回列表中元素的索引
          this.idList.splice(detail.index, 1)
          // console.log('确认')
        })
        .catch(() => {
          return
          // console.log('取消')
        })
    },

    createUploader(type) {
      let self = this
      // eslint-disable-next-line
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userIdAli,
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          let title = uploadInfo.file.name.substr(0, uploadInfo.file.name.lastIndexOf('.'))
          // 获取上传凭证需要的参数，可选
          let params = {
            title: title,
            fileName: uploadInfo.file.name
          }
          axios
            .get(`${process.env.VUE_APP_BASE_API}/pictureWork/getVoucher`, {
              params: params,
              headers: {
                // 设置请求头
                token: self.Authorization
              }
            })
            .then((data) => {
              // console.log(data)
              // console.log(data.data.data)
              let uploadAuth = data.data.data.uploadAuth
              let uploadAddress = data.data.data.uploadAddress
              let videoId = data.data.data.videoId
              self.videoId.push(data.data.data.videoId)
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
            })
            .catch(async (err) => {
              console.log('123')
              self.show = false
              Toast.fail('网络繁忙，请稍后刷新重新投稿')
            })
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          console.log(uploadInfo)
          self.emitEvent(uploadInfo.videoId)
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          self.closeVideoFail()
          self.videoId.pop()
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {},
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          let progressPercent = Math.ceil(progress * 100)
          self.authProgress = progressPercent
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {},
        onUploadTokenExpired: function (uploadInfo) {
          // 如果是上传方式二即根据STSToken实现时，从新获取STS临时账号用于恢复上传
          // 上传文件过大时可能在上传过程中sts token就会失效, 所以需要在token过期的回调中调用resumeUploadWithSTSToken 方法
          console.log('456')
          Toast.fail('网络繁忙，请稍后刷新重新投稿')
          self.show = false
          var stsUrl = 'stsUrl'
          // 以下请求实现为示例，用于演示设置凭证
          // 获取 accessKeyId, accessKeySecret,secretToken 可能因AppServer实现有差异
          fetch(stsUrl)
            .then((res) => res.json())
            .then((data) => {
              var info = data.SecurityTokenInfo
              uploader.resumeUploadWithSTSToken(
                info.AccessKeyId,
                info.AccessKeySecret,
                info.SecretToken
              )
            })
        }
      })
      return uploader
    },
    emitEvent(vid) {
      this.idList.push(vid)
      this.show = false
    },
    //文件上传失败执行
    closeVideoFail() {
      this.$toast.fail('网络繁忙，请稍后刷新重新投稿')
      this.show = false
      this.fileListVideo = []
      this.mapVideoList = []
    },
    afterReadVideo1(file) {
      console.log(file)
      var userData = '{"Vod":{}}'
      this.uploader = this.createUploader1()
      this.uploader.addFile(file.file, null, null, null, userData)
      this.show = true
      this.uploader.startUpload()
    },
    createUploader1(type) {
      let self = this
      // eslint-disable-next-line
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userIdAli,
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          let title = uploadInfo.file.name.substr(0, uploadInfo.file.name.lastIndexOf('.'))
          // 获取上传凭证需要的参数，可选
          let params = {
            title: title,
            fileName: uploadInfo.file.name
          }
          // console.log(params)
          axios
            .get(`${process.env.VUE_APP_BASE_API}/pictureWork/getVoucher`, {
              params: params,
              headers: {
                // 设置请求头
                token: self.Authorization
              }
            })
            .then((data) => {
              // console.log(data.data)
              let uploadAuth = data.data.data.uploadAuth
              let uploadAddress = data.data.data.uploadAddress
              let videoId = data.data.data.videoId
              self.mapTiifList.push(data.data.data.videoId)
              self.tiffNameList.push(data.data.data.videoId)
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
              // console.log(self.mapTiifList)
            })
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.show = false
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          self.$toast.fail('请检查文件再次上传。')
          self.show = false
          self.fileListTiff = []
          self.tiffNameList.pop()
          self.mapTiifList.pop()
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {},
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          let progressPercent = Math.ceil(progress * 100)
          self.authProgress = progressPercent
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {},
        onUploadTokenExpired: function (uploadInfo) {
          // 如果是上传方式二即根据STSToken实现时，从新获取STS临时账号用于恢复上传
          // 上传文件过大时可能在上传过程中sts token就会失效, 所以需要在token过期的回调中调用resumeUploadWithSTSToken 方法

          var stsUrl = 'stsUrl'
          // 以下请求实现为示例，用于演示设置凭证
          // 获取 accessKeyId, accessKeySecret,secretToken 可能因AppServer实现有差异
          fetch(stsUrl)
            .then((res) => res.json())
            .then((data) => {
              var info = data.SecurityTokenInfo
              uploader.resumeUploadWithSTSToken(
                info.AccessKeyId,
                info.AccessKeySecret,
                info.SecretToken
              )
            })
        }
      })
      return uploader
    },
    //上传tiff
    afterReadTiff(file) {
      this.show = true
      var self = this
      var names = file.file.name.replace(/ +/g, '')
      var name = names.replace(/\+/g, '')
      var getName = process.env.VUE_APP_UPLOAD_API + name
      var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
      client()
        .multipartUpload(fileName, file.file, {
          progress: function (p, cpt, res) {
            let ps = parseInt(p.toFixed(2) * 100)
            self.authProgress = ps
          }
        })
        .then((res) => {
          let imageUrlObj = {}
          imageUrlObj.fileName = res.res.requestUrls[0]
          imageUrlObj.fileUrl = res.res.requestUrls[0]
          imageUrlObj.fileType = 1
          imageUrlObj.type = 1
          var index = imageUrlObj.fileName.lastIndexOf('?')
          imageUrlObj.fileName = imageUrlObj.fileName.slice(0, index)
          imageUrlObj.fileUrl = imageUrlObj.fileName
          file.status = ''
          file.message = ''
          this.tiffNameList.push(getName)
          this.mapTiifList.push(imageUrlObj.fileUrl)
          this.show = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //删除tiff回调
    closeImgTiff(file, detail) {
      Dialog.confirm({
        message: '确定要删除此视频吗'
      })
        .then(() => {
          this.mapTiifList.splice(detail.index, 1)
          this.tiffNameList.splice(detail.index, 1)
          this.fileListTiff.splice(detail.index, 1)
        })
        .catch(() => {
          return
        })

      // this.mapTiifList.splice(detail.index, 1)
      // this.tiffNameList.splice(detail.index, 1)
      // this.fileListTiff.splice(detail.index, 1)
      // let vm = this
      // return new Promise((resolve, reject) => {
      //   // 将压缩后的图片删除
      //   vm.fileListTiff.splice(detail.index, 1)
      //   vm.mapTiifList.splice(detail.index, 1)
      //   vm.tiffNameList.splice(detail.index, 1)
      //   resolve()
      // })
    },
    async getVerdict() {
      let workList = this.imgNameList.map((el) => {
        return el.name
      })
      let workTiffList = this.tiffNameList.map((el) => {
        return el.name
      })
      let workVideoList = this.videoName.map((el) => {
        return el.name
      })
      const query = {
        activityId: this.id,
        workList,
        workTiffList,
        workVideoList
      }
      const { data: res } = await verdictSave(query)
      if (res.resultCode === 200) {
        this.submitClick()
      } else if (res.resultCode === 500) {
        Toast.fail(res.message)
      }
    },
    btn() {
      // console.log(this.tiffNameList);
      if (this.checkedAgges) {
        this.$refs.form
          .validate()
          .then(() => {
            this.submitClick()
          })
          .catch(() => {
            // this.submitClick()
            this.$toast.fail(this.$t('message.activity_upload_works.complete'))
          })
      } else {
        this.$toast.fail(this.$t('message.activity_upload_works.tick_privacy'))
      }
    },
    //点击返回
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-uploader__preview {
  width: 80px;
}
.upload_works {
  width: 100%;
  overflow: hidden;

  .new_form_title {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 0;
    display: flex;
    margin-top: 20px;
    flex-direction: row;
    align-items: center;

    span {
      width: 4px;
      height: 22px;
      display: block;
      margin-right: 12px;
      background: #3562ff;
    }

    p {
      margin: 0;
      color: #263245;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .pop_show {
    box-sizing: border-box;
    padding: 0 20px;
    margin: 40px auto;

    .name {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .pop_cenll {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
  }

  .upload_works_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px 20px;
    color: #1a1a1a;
    font-size: 12px;
    font-weight: 400;

    i {
      color: #92b3e3;
    }

    span {
      color: #3360ff;
    }
  }

  .show_tou {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;

    h4 {
      box-sizing: border-box;
      padding: 0 20px;
    }
  }

  .tou_pop {
    width: 90%;
    height: 60%;
    border-radius: 12px;
  }

  .fixed {
    position: fixed;
    right: 10px;
    top: 300px;
    z-index: 99;
    box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);

    img {
      width: 60px;
      height: 60px;
    }
  }

  .text_pop {
    width: 90%;
    height: 80%;
    border-radius: 12px;
  }

  .tiff {
    /deep/.van-uploader__wrapper {
      width: 100% !important;
    }

    /deep/.van-uploader__input-wrapper {
      width: 100% !important;
    }
  }

  .upload_works_flex {
    width: 100%;
    overflow: hidden;

    /deep/ .van-cell {
      display: flex;
      flex-direction: column !important;

      .van-cell__title {
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 10px;
      }
    }

    .flex {
      display: flex;
      // flex-direction: column;
      /deep/.van-uploader__wrapper {
        display: block;
      }
      /deep/.van-uploader__preview-image {
        display: inline-block;
      }
      .annotation {
        height: 87px;
        display: flex;
        margin: 0 8px 8px 0;
        align-items: center;
      }
      .span {
        color: #999999;
        font-size: 10px;
        font-weight: 400;
        line-height: 12px;
      }
    }
  }
  .flex_sb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 20px 16px 10px 16px;
    background-color: #fff;

    p {
      margin: 0;
      color: #263245;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .p {
    font-size: 12px;
    box-sizing: border-box;
    padding: 20px 16px 10px 16px;
    color: #999999;
    background: #fff;
    font-weight: 400;
    margin-top: 30px;

    span {
      color: #3360ff;
    }
  }

  .div {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    padding: 10px 16px;
    background-color: #fff;

    .aggess {
      display: flex;
      align-items: center;
      color: #263245;
      font-size: 12px;
      font-weight: 400;

      span {
        color: #3360ff;
      }
    }
  }

  .btn {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    padding: 60px 20px 30px 20px;
    background-color: #fff;
    text-align: center;

    button {
      width: 240px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      padding: 0;
      border: none;
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      border-radius: 16px;
    }
  }

  /deep/ .van-circle__text {
    color: #fff !important;
  }
}
</style>
